import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '../icon/icon.module';

/** Optional leading icon beside the page title, matching the super-admin portal. */
export type PageSurfaceTitleIcon =
  | 'dashboard'
  | 'cpu-bolt'
  | 'users'
  | 'user'
  | 'link'
  | 'checks'
  | 'clock'
  | 'clipboard'
  | 'bell'
  | 'billing'
  | 'settings'
  | 'lock';

export interface PageSurfaceTab {
  key: string;
  label: string;
}

@Component({
  selector: 'app-page-surface-header',
  standalone: true,
  imports: [CommonModule, IconModule],
  templateUrl: './page-surface-header.component.html',
})
export class PageSurfaceHeaderComponent {
  @Input({ required: true }) title!: string;
  @Input() titleIcon?: PageSurfaceTitleIcon | null;
  @Input() subtitle = '';
  @Input() tabs: PageSurfaceTab[] = [];
  @Input() activeTabKey = '';
  @Input() tablistLabel = '';
  @Input() compact = false;

  @Output() activeTabKeyChange = new EventEmitter<string>();

  get ariaTablistLabel(): string {
    return this.tablistLabel || this.title;
  }

  selectTab(key: string): void {
    if (key !== this.activeTabKey) {
      this.activeTabKeyChange.emit(key);
    }
  }
}
